import type { ButtonProps } from '@_/ui';
import { DialogPrimitiveClose } from '@_/ui';
import { FormCancelButton } from './FormCancelButton.tsx';

export function FormDialogCancelButton(props: ButtonProps) {
  return (
    <DialogPrimitiveClose asChild>
      <FormCancelButton {...props} />
    </DialogPrimitiveClose>
  );
}
